export const EXPERIENCE = [
    {
        type: "job",
        data: {
            "workTitle": "Senior Software Developer",
            "techstack": [],
            "description": [
                "Implemented OpenTelemetry observability for a mission-critical **.NET service** managing thousands of stateful connections with customer installed backup agents, enabling distributed tracing and metrics that improved debugging and resolved production scaling bottlenecks.",
                "Authored technical documentation evaluating cost-effective solutions for local testing of cloud-dependent features presented findings to multiple teams and stakeholders, enabling adoption that reduced AWS expenses and accelerated early-stage development.",
                "Designed and documented **AWS WAF rules** for internal and external API-Gateways, providing a single source of truth for security teams; supplemented with **CloudWatch alarms** to monitor anomalies and ensure proactive issue detection, strengthening the system’s security posture."
            ],
            "timeline": "Jul 2021 - Nov 2023",
            "company": {
                "name": "OpenText",
                "link": "https://www.opentext.com/ca"
            }
        }
    },
    {
        type: "job",
        data: {
            "workTitle": "Software Developer",
            "techstack": [],
            "description": [
                "Maintained and enhanced a large legacy .NET Framework and JavaScript based codebase for a SaaS product, incrementally migrating legacy patterns to modern standards while safeguarding customer workflows, reducing regressions, and improving maintainability to enable faster delivery of new features.",
                "Created step-by-step on-boarding videos for web based SaaS product, covering setup and feature development workflows;mentored new engineers by improving ramp-up time and providing a lasting reference they continue to use."
            ],
            "timeline": "Jul 2021 - Nov 2023",
            "company": {
                "name": "OpenText",
                "link": "https://www.opentext.com/ca"
            }
        }
    },
    {
        type: "hackathon",
        data: {
            "workTitle": "Technical Lead",
            "timeline": "Jul 2022",
            "company": {
                "name": "HackRX2022",
                "link": "https://uwaterloo.ca/pharmacy/news/hackrx-us-students-across-canada-invited-pharmacy-and"
            },
            "project": {
                "title": "Give Care",
                "repository_url": "https://github.com/felicityy-li/Give-Care"
            },
            "challenge": "",
            "description": "Give Care is a tool designed to help caregivers manage their loved one's vaccines, medications, lab tests, and appointments. It connects caregivers with pharmacists to optimize their patients health outcomes.",
            "techstack": ["NodeJs", "SQL", "ReactJs", "Twilio"],
            "responsibilities": [
                "Developed a NodeJs and SQL based web application prototype for caregivers to manage medical records and appointments on behalf of their patients.",
                "Led a team of two developers, establishing project guidelines and timelines, resulting in rapid transition from concept to prototype within 48 hours.",
                "Learned and implemented Twilio Messaging API to provide SMS based appointment reminders to caregivers."
            ],
            "outcome": [
                "Earned 🏆 3rd place out of 12 competing teams for the project, demonstrating strong problem-solving and innovation."
            ]
        }
    },
    {
        type: "job",
        data: {
            "workTitle": "DevOps Developer",
            "techstack": [],
            "description": [
                "Built a **NodeJs** automation service to migrate **two years** of employee time tracking data between legacy and new systems, integrating both APIs and implementing tests to ensure data integrity; optimized API calls via caching, reducing redundant requests, lowering system load, and improving migration efficiency.",
                "Designed and implemented automated CI/CD pipelines using **Jenkins** and a shared library architecture, standardizing repeatable deployment steps; reduced manual effort and errors, cutting deployment time from a slow, multi-hour process to under **15 minutes** and significantly improving team productivity and release velocity."
            ],
            "responsibilities": [

            ],
            "accomplishments": [

            ],
            "timeline": "May 2020 - Jun 2021",
            "company": {
                "name": "Tekside.IO",
                "link": "https://www.clarovant.io/"
            }
        }
    },
    {
        type: "job",
        data: {
            "workTitle": "Development and Support Specialist Co-Op",
            "description": [
                "Focused on DevOps engineering by building infrastructure and automation for deployment workflows.",
                "Adopted Kubernetes and Rancher, learned YAML deployment authoring, and mastered Docker single-node and swarm setups.",
                "Gained hands-on experience with containers, services, stacks, networking, and RabbitMQ messaging patterns.",
                "Shifted pipeline development from workspace-based builds to reusable pipeline-as-code libraries, improving reliability and maintainability.",
                "Contributed to a major deployment speedup by replacing shell-scripted steps with Jenkins pipeline automation."
            ],
            "timeline": "Jan 2019 - Aug 2019",
            "company": {
                "name": "Tekside.IO",
                "link": "https://www.clarovant.io/"
            }
        }
    },
    {
        type: "job",
        data: {
            "workTitle": "Development and Support Co-Op",
            "description": [
                "Built an **Admin portal** with Node.js and Express for managing email subscriptions, including login, bulk edit, and multi-select controls.",
                "Implemented authorization flows and presented the prototype at a company-wide showcase.",
                "Shifted from server-side rendering to React, developing a modern portal version using class components, state, and props.",
                "Strengthened full-stack skills while delivering a polished admin experience."
            ],
            "accomplishments": [
            ],
            "timeline": "Jun 2018 - Sep 2018",
            "company": {
                "name": "Inbox Marketer",
                "link": "https://ca.linkedin.com/company/inbox-marketer"
            }
        }
    },
    {
        type: "job",
        data: {
            "workTitle": "Development and Support Co-Op",
            "description": [
                "Supported client success by troubleshooting email marketing workflows and mastering the **CONNECT Messaging Platform**.",
                "Delivered email content fixes using HTML, CSS, JavaScript, and jQuery while improving turnaround for client requests.",
                "Created handwritten documentation for PHP learnings and used Postman to explore REST APIs for the first time.",
                "Built a PHP/Symfony side project, **Patient Medication Tracker**, to apply new web development skills in a real product."
            ],
            "timeline": "Jun 2017 - Sep 2017",
            "company": {
                "name": "Inbox Marketer",
                "link": "https://ca.linkedin.com/company/inbox-marketer"
            }
        }
    }
]
